import { useTranslation } from 'react-i18next';
import AnswerContainer from './answer-container';
import NovartisLiveChatButton from './novartis-live-chat-button';
import { IMessage, MessageType, Modals } from '../../common/types';
import MarkdownRenderer from '../common/markdown-renderer';
import { Button } from '../ui/button';

interface SystemMessageProps {
  message?: IMessage;
  showModal?: (type: Modals, userQuery?: string) => void;
  userQuery?: string;
}

function SystemMessage(props: SystemMessageProps) {
  const { t } = useTranslation();

  if (!props.message?.message) return null;

  return (
    <AnswerContainer>
      <MarkdownRenderer content={props.message?.message} />
      {props.message.type === MessageType.DisabledTopicMessage && props.showModal && (
        <div className="mt-4 flex flex-col gap-2 sm:flex-row">
          <Button
            className="w-full sm:w-auto"
            onClick={() => props.showModal?.(Modals.MedicalInfo, props.userQuery)}
          >
            {t('chat.info_service')}
          </Button>
          <NovartisLiveChatButton inline query={props.userQuery} />
        </div>
      )}
    </AnswerContainer>
  );
}

export default SystemMessage;
